import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/components/style/common.scss';
import Axios from "axios";
import store from './store'

const env = process.env.NODE_ENV === 'development' ? 'development' :
  process.env.VUE_APP_TITLE === 'test' ? 'test' : 'production';
const urls ={
  sendMessage:""
};

if(env === "development"){
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://apitest.xianlaigame.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://apitest.xianlaigame.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://apimalltest.xianlaigame.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "juezhan":"XL_bcad403c0ae96ef6e0e971ff1c2b2a14",
    "jiandang":"xl9034c488e76d81ec",
    "zhizun":"xl126b376b5fd23de1"
  }
}else{
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://api.wxianlai.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://api.wxianlai.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://api.wxianlai.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "juezhan":"xlbef0baa7edf72cd4",
    "jiandang": "xl701c8127b52ad81b",
    "zhizun": "xl178c860d2778583d"
  };
 /* //TODO:线上环境删除以下代码
  urls.sendMessage = "/pttool/v1/sms/send/code";
  urls.uc = "https://apitest.xianlaigame.com";
  urls.oauth = "/oauth/v1/user/identitynumber";
  urls.check = "/oauth/user/bind/tel/verify";
  urls.ams = 'https://apitest.xianlaigame.com/ams/v1/user/asset/';
  urls.ganmeInfo = 'https://apimalltest.xianlaigame.com/co/v1/wechat/gameInfo';
  urls.gamesKey = {
    "juezhan":"XL_bcad403c0ae96ef6e0e971ff1c2b2a14",
    "jiandang":"xl8fb498b1961375ce",
    "zhizun":"xl23c2182418d6f75b"
  }*/
}
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
Vue.prototype.$ajaxUrls = urls;

let lastLogTime = window.sessionStorage.getItem('loginTime');
let nowTime = new Date().getTime();
if(lastLogTime !== null && lastLogTime !== undefined && lastLogTime !== ""){
  if((nowTime - lastLogTime)<14400000){
    store.state.haslogin = true;
    store.state.userData = JSON.parse(window.sessionStorage.getItem("userData"));
    store.state.asset = JSON.parse(window.sessionStorage.getItem("asset"));
    Vue.prototype.$ajaxUrls.appKey =window.sessionStorage.getItem("appKey");
  }else{
    router.push({name:"home"})
  }
}
router.afterEach((to, from) => {
  document.documentElement.scrollTop = 0;
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
